<template>
  <div>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              outlined
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
          >
            ΛΗΨΗ
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="printElem()" v-if="!isMobile">
            <v-list-item-title>ΕΚΤΥΠΩΣΗ</v-list-item-title>
          </v-list-item>
          <v-list-item @click="toPdf()" >
            <v-list-item-title>PDF</v-list-item-title>
          </v-list-item>
          <v-list-item @click="toExcel()" v-if="!hideExcel">
            <v-list-item-title>EXCEL</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    <v-dialog v-model="dialog">
      <v-card class="text-center">
        <v-icon color="green" size="100">mdi-check</v-icon>
        <v-card-text>
          <h3>
            Το αρχείο pdf αποθηκεύτηκε στην συσκευή σας.
          </h3>
          <v-btn color="primary" text @click="dialog=false; "> OK</v-btn>
        </v-card-text>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import {mapGetters} from "vuex";
import moment from "moment";
import XLSX from "xlsx";

export default {
  name: "PrintPdfButton",
  props: {
    pageTitle: {type: String, default: null, required: false},
    idToPrint: {type: String, default: null, required: false},
    hideExcel: {type: Boolean, default: null, required: false}
  },
  computed: {
    ...mapGetters([
      'isMobile'
    ])
  },
  methods: {

    toPdf() {
      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      mywindow.document.write('<html><head><title>' + this.pageTitle + '</title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<h1>' + this.pageTitle + '</h1>');
      mywindow.document.write(document.getElementById(this.idToPrint).innerHTML);
      mywindow.document.write('</body></html>');
      html2pdf()
          .set({
            filename: this.pageTitle + '-' + moment().format('DD-MM-YY') + '.pdf'
          })
          .from(mywindow.document.body)
          .save()
          .then(res => {
            mywindow.focus();
            mywindow.close();
            this.dialog = true;
          })
    },
    printElem() {
      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      mywindow.document.write('<html><head><title>' + this.pageTitle + '</title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<h1>' + this.pageTitle + '</h1>');
      mywindow.document.write(document.getElementById(this.idToPrint).innerHTML);
      mywindow.document.write('</body></html>');
      mywindow.print();
      mywindow.focus();
      mywindow.close();
      return true;
    },
    toExcel() {
      let table = document.getElementById(this.idToPrint);
      let wb = XLSX.utils.table_to_book(table, {sheet: "Sheet JS"});
      XLSX.writeFile(wb, this.pageTitle + '.xlsx')
    }
  }
  ,
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped>

</style>
